import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { NoticesService } from 'src/app/services/notices/notices.service';

@Component({
  selector: 'app-notice-item',
  templateUrl: './notice-item.component.html',
  styleUrls: ['./notice-item.component.scss'],
})
export class NoticeItemComponent implements OnInit {
  id: string;
  sub: Subscription[] = [];
  notice: any;
  constructor(
    private noticeService: NoticesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.sub[0] = this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      this.noticeService.searchNotice(this.id);
    });
    this.sub[1] = this.noticeService.noticeItemChnage.subscribe((notice) => {
      this.notice = notice;
    });
  }
}
